<template>
  <div class="goods-ceil-container">
    <div class="ceil-container" v-for="(item, index) in mealsList" :key="index">
      <div class="img-box" @click="toDetailPage(item.id)">
        <img v-lazy="item.image ? item.image : $defaultImg" class="c-pointer" />
      </div>
      <div class="price">
        <span class="span1" v-if="$store.state.hasLogin"
          ><i>￥</i>{{ item.amount }}</span
        >
        <!-- <span class="span2"><i>￥</i>{{item.purchasePrice}}</span> -->
      </div>
      <div class="name">
        <span class="c-pointer" @click="toDetailPage(item.id)">
          <!-- <i v-if="item.goodsActivityInfoMap.activity">{{item.goodsActivityInfoMap.activityDescription}}</i> -->
          {{ item.name }}
        </span>
      </div>
      <!-- <div class="stock">
      <span class="span1">库存：</span>
      <span>{{item.stock}}</span>
    </div> -->
      <!-- <div class="add">
        <input-number :maxNumber="item.stock" ref="inputNumber"></input-number>
        <span class="add-cart no-select" @click="add(item, index)"
          >加入购物车</span
        > -->
        <!-- <span class="remind no-select" >到货提醒</span> -->
      <!-- </div> -->
    </div>
    <popup
      class="popup-info"
      width="350px"
      height="200px"
      @close="close"
      v-if="show"
    >
      <div>
        <div class="header">
          <span>出错提示</span>
          <img
            class="close2"
            :src="require('@/assets/images/x.png')"
            alt=""
            @click="close"
          />
        </div>
        <div class="middle">
          <img
            class="errimg"
            :src="require('@/assets/images/t_s.png')"
            alt=""
          />
          <span>{{ message }}</span>
        </div>
      </div>
    </popup>
    <success v-if="successShow">加购成功</success>
  </div>
</template>

<script>
import inputNumber from "../../../../components/input-number";

export default {
  components: { inputNumber },
  data() {
    return {
      successShow: false,
      show: false,
      message: "",
    };
  },
  created() {},
  props: ["mealsList"],
  methods: {
    toDetailPage(id) {
      this.$router.push({
        name: "detail",
        query: {
          goodsId: id,
          type: 2,
        },
      });
    },
    success() {
      this.successShow = false;
    },
    add(item, index) {
      if (!this.$store.state.hasLogin)
        return this.$router.push({ path: "/login" });
      let num = this.$refs.inputNumber[index].number;
      let id = item.id;
      //console.log(item,num)
      this.$api
        .POST_ADDCART({
          cartItemType: "combination", //combination
          id,
          quantity: num,
        })
        .then((res) => {
          if (res.status) {
            //console.log(res);
            this.successShow = true;
            this.$store.commit(
              "GETCARTCOUNT",
              Number(this.$store.state.cartNum) + Number(num)
            );
          } else {
            this.show = true;
            this.message = res.message;
          }
        });
    },
    close() {
      this.show = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.goods-ceil-container {
  overflow: hidden;
}
.ceil-container {
  background-color: #ffffff;
  float: left;
  margin: 5px 5px 10px;
  padding: 10px 15px;
  width: 230px;
  height: 340px;
  border-radius: 3px;
  &:hover {
    box-shadow: 0 0 10px 1px #e5e5e5;
  }
  .img-box {
    text-align: center;
    margin-bottom: 14px;
    img {
      width: 200px;
      height: 200px;
    }
  }
  .price {
    margin-bottom: 10px;
    .span1 {
      font-size: 20px;
      color: #fa4b4b;
      font-weight: 600;
      i {
        font-size: 13px;
      }
    }
    .span2 {
      font-size: 13px;
      color: #999999;
      text-decoration: line-through;
    }
  }
  .name {
    margin-bottom: 18px;
    p {
      font-size: 14px;
      color: #505050;
      line-height: 24px;
      height: 48px;
      @include textLineClamp(2);
      i {
        min-width: 40px;
        height: 20px;
        display: inline-block;
        border: 1px solid #fa4b4b;
        font-size: 12px;
        line-height: 20px;
        text-align: center;
        color: #fa4b4b;
        border-radius: 2px;
        padding: 0 4px;
      }
    }

    .span2 {
      margin-top: 30px;
      word-wrap: break-word;
    }
  }
  .stock {
    font-size: 13px;
    color: #808080;
    margin-bottom: 20px;
  }
  .add {
    display: flex;
    span {
      width: 80px;
      height: 32px;
      display: inline-block;
      background: #fa4b4b;
      border-radius: 3px;
      color: #ffffff;
      font-size: 14px;
      margin-left: 10px;
      text-align: center;
      line-height: 32px;
      cursor: pointer;
    }
    .remind {
      background: rgb(255, 204, 81);
    }
  }
}
.header {
  height: 44px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #f8f8f8;
  span {
    font-size: 17px;
    color: #333333;
    font-weight: bold;
    margin-left: 17px;
  }
  .close2 {
    width: 15px;
    height: 15px;
    position: absolute;
    right: 20px;
    cursor: pointer;
  }
}
.middle {
  align-items: center;
  @include flex-d-c;
  img {
    width: 104px;
    height: 83px;
    margin: 12px 0;
  }
  span {
    font-size: 16px;
    color: #333333;
    padding: 0 30px;
    text-align: center;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/main/meal/components/goods-meal-ceil.vue